import axios from "axios";
import qs from "qs";

//该位置为配置哪些路由的地址免登录可以发送post和get请求
axios.interceptors.request.use(
  config => {
    if (sessionStorage.token) {
      config.headers.token = `${sessionStorage.token}`;
    } else {
      let userType = sessionStorage.userType;
      let href = location.href;
      if (
        href.indexOf("login") < 0 &&
        href.indexOf("adminLogin") < 0 &&
        href.indexOf("mobile/login") < 0 &&
        href.indexOf("mobile/dingLogin") < 0 &&
        href.indexOf("/wechat/auth") < 0 &&
        href.indexOf("/dingTalk/auth") < 0 &&
        href.indexOf("/mobile/mobileCustomerSatisfactionEdit") < 0 &&
        href.indexOf("/customerManage/customerSatisfactionEdit") < 0 &&
        href.indexOf("/addRepairCustomer") < 0 &&//客户需求登记   该位置为配置哪些路由的地址免登录可以发送post和get请求
        href.indexOf("/repairCustomerIndex") < 0 &&//客户需求登记
        href.indexOf("/repairCustomerList") < 0 &&//客户需求登记
        // href.indexOf("/mobileAfterSaleChatLLM") < 0 &&//移动端对接内网的llm服务
        href.indexOf("/viewAndEditRepairCustomer") < 0 &&//客户需求登记
        href.indexOf("/materialManage/stock-transfer/abnormalForm-dingTalk") < 0 &&//钉钉异常处理
        href.indexOf("/materialManage/material-transfer/abnormalForm-dingTalk") < 0&&
        href.indexOf("/materialManage/purchase-receive/abnormalForm-dingTalk") < 0
      ) {
        console.log('h>>>>')
        if (userType === "superAdmin") {
          window.location.href = "/#/adminLogin";
        } else {
          if (href.indexOf("admin") > -1) {
            window.location.href = "/#/adminLogin";
          } else if (href.indexOf("dingLogin") > -1) {
            window.location.href = "/#/mobile/dingLogin";
          } else if (href.indexOf("mobile") > -1) {
            window.location.href = "/#/mobile/login";
          } else if (href.indexOf("wechat") > -1) {
            window.location.href = "/#/wechat/auth";
          } else if (href.indexOf("wechat") > -1) {
            window.location.href = "/#/dingTalk/auth";
          } else {
            window.location.href = "/#/login";
          }
        }
        alert("对不起，您尚未登录，请先登录！");
      }
    }
    return config;
  },
  err => {
    return Promise.reject(err);
  }
);

export default {
  //添加contentType参数区分数据以那种数据格式
  post(url, data, success_call, fail_callback, contentType) {
    for (var key in data) {
      //js判断是否为字符串
      if (typeof data[key] == "string") {
        data[key] = data[key].replace(/(^\s*)|(\s*$)/g, "");
      }
    }
    return axios
      .post(url, contentType === 'json' ? data : qs.stringify(data))
      .then(function (response) {
        if (response.data.code != 200) {
          if (fail_callback) {
            fail_callback(response.data);
          }
        } else {
          if (success_call) {
            success_call(response.data);
          }
        }
      })
      .catch(function (error) {
      });
  },

  get(url, params, success_callback, fail_callback) {
    // params['token'] = localStorage.token;
    for (var key in params) {
      //js判断是否为字符串
      if (typeof params[key] == "string") {
        params[key] = params[key].replace(/(^\s*)|(\s*$)/g, "");
      }
    }
    return axios
      .get(url, {
        params: params
      })
      .then(function (response) {
        if (response.data.code == 200) {
          if (success_callback) {
            success_callback(response.data.data);
          }
        } else if (fail_callback) {
          fail_callback(response.data);
        }
      })
      .catch(function (error) {
         console.log(error);
      });
  },
  postExcel(url, data, success_call, fail_callback, contentType) {
    for (var key in data) {
      //js判断是否为字符串
      if (typeof data[key] == "string") {
        data[key] = data[key].replace(/(^\s*)|(\s*$)/g, "");
      }
    }
    return axios
      .post(url,data,
      {
        responseType: 'blob',
        timeout: 60000
      })
      .then( (response)=> {
        // 检查是否是错误（比如后端返回 JSON 错误）
        if (response.data.type === 'application/json') {
          const text = response.data.text();
          const err = JSON.parse(text);
          return;
        }
        // 下载文件
        if (response.data.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
          const blob = new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          });
          //为这个 Blob 对象生成一个 临时的、本地的 URL
          //这个 URL 只在当前页面有效，关闭页面后自动失效。
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = '物料消耗明细.xlsx';
          document.body.appendChild(a); // 部分浏览器需要 append
          a.click();
          document.body.removeChild(a);// 立即移除，避免污染 DOM
          window.URL.revokeObjectURL(url);//释放内存
        }
        if (response.status != 200) {
          if (fail_callback) {
            fail_callback(response.data);
          }
        } else {
          if (success_call) {
            success_call(response.data);
          }
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }
};



// WEBPACK FOOTER //
// ./src/assets/js/request.js